<div class="profile-wrapper" >
  @if (headerLayout === 'staff') {

  <app-common-header
  *ngIf="headerLayout === 'staff'"

  [headerLayout]="'staff'"
  [logoSrc]="logoSrc"
  [profileImageSrc]="profileImageSrc"
  [showProfileMenu]="showProfileMenu"
  [menuButtons]="menuButtons"
  (sealIconClick)="onGeoPermitLogoClick()">
</app-common-header>
  }@else if (headerLayout === 'applicant') {

<div style="width:100%" >
  <app-common-header
  *ngIf="headerLayout === 'applicant'"

  [headerLayout]="'applicant'"
  [logoSrc]="logoApplicantSrc"
  [userNameData]="userNameData"
  [profileImageSrc]="profileImageSrc"
  [profileImageClass]="profileImageClass"
  [showProfileMenu]="showProfileMenuOfApplication"
  [onEditProfile]="goToEditProfile"
  [onChangePassword]="goToChangePassword"
  [onLogout]="onSignOutClick"
  (sealIconClick)="onGeoPermitLogoClick()">
</app-common-header>
</div>
  }

  <div class="profile-layout"
  [ngClass]="headerLayout === 'staff' ? 'mt-staff' : 'mt-default'">
    <wm-profile-image-section></wm-profile-image-section>
    <wm-profile-form></wm-profile-form>
  </div>
</div>
<!-- sign out modal -->
<wm-common-confirmation-modal [data]="signOutModalData" (onYesClick)="handleSignOutModalAccepted()"
    (onNoClick)="handleSignOutModalModalRejected()">
</wm-common-confirmation-modal>
